import { render, staticRenderFns } from "./InGoogleDialog.vue?vue&type=template&id=54a79dd0&scoped=true&"
import script from "./InGoogleDialog.vue?vue&type=script&lang=js&"
export * from "./InGoogleDialog.vue?vue&type=script&lang=js&"
import style0 from "./InGoogleDialog.vue?vue&type=style&index=0&id=54a79dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a79dd0",
  null
  
)

export default component.exports